import { createFileRoute } from '@tanstack/react-router';

import { StaffTicketDetailView } from 'src/sections/staff/ticket/ticket-detail-view';

export const Route = createFileRoute('/w/tickets/$ticketId')({
  component: StaffTicketPage,
});

function StaffTicketPage() {
  const { ticketId } = Route.useParams();
  return <StaffTicketDetailView ticketId={ticketId} />;
}
